<template>
    <div class="row">
        <div class="col-12">
            <small class="font-weight-bold">{{ data.type == 'D' ? 'DEFECTO' : 'CASO ' + id }}: </small>
        </div>
        <div class="col-lg-6 px-0" v-for="(item, index) in data.values" :key="index">
            <div class="row">
                <div class="col-lg-10 px-0">
                    <div class="row">
                        <div class="col-lg-4 px-1 mb-2">
                            <input class="form-control form-control-sm" v-model="item.min" @keypress="DOUBLE" 
                            :ref="'values' + index + 'min'" 
                            @focus="SET_INPUT('values.' + index + '.min')" 
                            @input="GET_INPUT">
                        </div>
                        <div class="col-lg-4 px-1 mb-2">
                            <v-select
                                :items="operators"
                                v-model="item.operator"
                                hide-details
                                class="form-control form-control-sm">
                            </v-select>
                        </div>
                        <div class="col-lg-4 px-1 mb-2">
                            <input type="text" v-model="item.max" class="form-control form-control-sm" @keypress="DOUBLE" 
                            :ref="'values' + index + 'max'" 
                            @focus="SET_INPUT('values.' + index + '.max')" 
                            @input="GET_INPUT">
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 px-lg-0 px-1 mb-2">
                    <v-select
                        :items="conditions"
                        v-model="item.condition"
                        @change="ADD_REMOVE_ITEM(index)"
                        :disabled="item.disabled"
                        hide-details
                        class="form-control form-control-sm">
                    </v-select>
                </div>
            </div>
        </div>
        <div class="col-12 mb-3"></div>
        <div class="col-lg-1">
            <small class="font-weight-bold">RETORNA </small>
        </div>
        <div class="col-lg-1 px-1 mb-2">
            <input class="form-control form-control-sm" v-model="data.value" 
            :ref="'value'" 
            @focus="SET_INPUT('value')" 
            @input="GET_INPUT">
        </div>
        <div class="col-lg-1 px-1 mb-2" v-if="no_discount">
            <v-select v-model="data.no_discount"
                :items="actions"
                hide-details
                :ref="'no_discount'" 
                @focus="SET_INPUT('no_discount')" 
                class="form-control form-control-sm">
            </v-select>
        </div>
        <div class="col-lg-1" v-if="data.type != 'D'">
            <button @click="REMOVE(data.id)" type="button" class="btn btn-h btn-danger">
                <span><i class="bi bi-x"></i></span>
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Object
        },
        id: {
            type: Number | String
        },
        btn: {
            type: Number | String
        },
        add_text: {
            type: Number | String
        },
        set_id: {
            type: Number | String
        },
        no_discount: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            input: '',
            operators: [
                '',
                '==',
                '>',
                '<',
                '>=',
                '<=',
            ],
            conditions: [
                '',
                '&&',
                '||',
            ],
            mats: [
                '',
                '+',
                '-',
                '*',
                '/',
            ],
            actions: [
                true,
                false
            ],
            set_value: '',
        }
    },
    methods: {
        ADD_TEXT: function(input){
            let vue = this
            if(vue.set_id == vue.id){
                let split = vue.input.split('.')
                if(split.length == 1){
                    if(vue.data[split[0]] != vue.btn){
                        vue.data[split[0]] = vue.btn
                    }
                }else{
                    if(vue.data[split[0]][split[1]][split[2]] != vue.btn){
                        vue.data[split[0]][split[1]][split[2]] = vue.btn
                    }
                }
            }
        },
        SET_INPUT: function(input){
            let vue = this
            vue.$emit('set_id', vue.id)
            vue.input = input
            let split = vue.input.split('.')
            if(split.length == 1){
                vue.set_value = vue.data[split[0]]
            }else{
                vue.set_value = vue.data[split[0]][split[1]][split[2]]
            }
        },
        GET_INPUT: function(){
            let vue = this
            if(vue.set_id == vue.id){
                let split = vue.input.split('.')
                if(split.length == 1){
                    if(vue.set_value == vue.btn){
                        vue.data[split[0]] = ''
                        vue.set_value = ''
                    }
                }else{
                    if(vue.set_value){
                        if(vue.set_value == vue.btn){
                            vue.data[split[0]][split[1]][split[2]] = ''
                            vue.set_value = ''
                        }
                    }
                }
            }
        },
        ADD_REMOVE_ITEM: function(index){
            let vue = this
            let condition = vue.data.values[index].condition
            condition = condition == '&&' || condition == '||' ? 1 : 0
            let count = vue.data.values.length
            if(count == (index+1) && condition == 1){
                if((index - 1) >= 0){
                    vue.data.values[index - 1]['disabled'] = true
                }
                vue.data.values.push({
                    min: '',
                    operator: '',
                    max: '',
                    condition: '',
                    disabled: false
                })
            }else{
                if(condition == 0){
                    if((index - 1) >= 0){
                        vue.data.values[index - 1]['disabled'] = false
                    }
                    vue.data.values.splice(index+1, 1)
                }
            }
            // if(count > 0){
                
            // }
        },
        REMOVE: function(id){
            this.$emit('remove', id)
        }
    },
    watch:{
        add_text: {
            handler(value) {
                let vue = this
                vue.ADD_TEXT(vue.btn)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/others/SwitchIf.vue